import { useDispatch, useSelector } from 'react-redux';
import { hidePlasticAddressModal, submitAddress } from '../actions/plasticAddressActions';
import { selectApplicationDetails, selectLandingDetails, selectShowPlasticAddressModal } from '../selectors';
import IAddress from '@sunbit-dev/common/models/IAddress';
import PlasticAddress from '@sunbit-dev/ui/src/components/card-apply/components/plasticAddress/PlasticAddress';
import { datadogRum } from '@sunbit-dev/common/services/datadog';
import { useMixpanel } from '../services/mixpanel/mixPanel';
import { MixpanelCardApplylEvent } from '@sunbit-dev/common/enums/cardApply/MixpanelCardApplylEvent';
import React, { SyntheticEvent, useEffect } from 'react';
import { getConfig } from '@sunbit-dev/common/services/config';
const IdentificationContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { trackForMixPanel } = useMixpanel();
  const plasticAddressModalVisible = useSelector(selectShowPlasticAddressModal);
  const applicationDetails = useSelector(selectApplicationDetails);
  const landingDetails = useSelector(selectLandingDetails);
  const isAddressAutocomplete: boolean = getConfig().getItem('featureFlags')?.isAddressAutocomplete;
  const isReferral = landingDetails.referringPartner ? true : false;
  const handleSubmitAddress = React.useCallback(
    async (address: IAddress) => {
      await dispatch(submitAddress(address, applicationDetails.applicationStatus));
      dispatch(hidePlasticAddressModal());
      address.zipcode = address.zipcode.replace(/[^\d]+/gi, '');
      datadogRum.addRumGlobalContext('customer-address', {
        address: address as any,
      });
    },
    [dispatch, applicationDetails.applicationStatus]
  );
  const onChangeAddressClick =
    (onClick: Function, mixPanelEvent: MixpanelCardApplylEvent) => (data?: IAddress | SyntheticEvent) => {
      trackForMixPanel(mixPanelEvent);
      onClick(data);
    };
  useEffect(() => {
    if (plasticAddressModalVisible) {
      trackForMixPanel(MixpanelCardApplylEvent.Addresspop_Views);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plasticAddressModalVisible]);

  return (
    <>
      {plasticAddressModalVisible && (
        <PlasticAddress
          isAddressAutocomplete={isAddressAutocomplete}
          onClickChangeAddress={onChangeAddressClick}
          submit={handleSubmitAddress}
          isReferral={isReferral}
          applicationDetails={applicationDetails}
        />
      )}
    </>
  );
};

export default IdentificationContainer;
